import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    computed,
    effect,
    inject,
    signal,
    untracked,
} from '@angular/core';
import {
    AppFeature,
    CampaignFeature,
    DealerFeature,
    EventTrackingService,
    RouterLinkDirective,
    TrackingFeature,
} from '@hyundai/ng-common-lib';
import {
    M040C015WarrentyFooterLogosComponent,
    M040C020RteComponent,
    M060C010VehicleShowroomWrapperComponent,
    M060C020VehicleLeasingExampleComponent,
    M060C030VehicleTeaserComponent,
} from '@hyundai/ui';
import { SimilarVehiclesComponent } from '@hyundai/vehicle-market-lib';
import { Store } from '@ngrx/store';
import { GlobalContactComponent } from '../../../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-campaign-detail-page-sales-campaign',
    standalone: true,
    templateUrl: './campaign-detail-page-sales-campaign.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        GlobalContactComponent,
        M040C015WarrentyFooterLogosComponent,
        M040C020RteComponent,
        M060C010VehicleShowroomWrapperComponent,
        M060C020VehicleLeasingExampleComponent,
        M060C030VehicleTeaserComponent,
        RouterLinkDirective,
        SimilarVehiclesComponent,
    ],
})
export class CampaignDetailPageSalesCampaignComponent {
    tracking = inject(EventTrackingService);

    store = inject(Store);
    campaignDetail = this.store.selectSignal(CampaignFeature.state.selectLoadedCampaignDetail);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    dealerLocationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    showOnlyPrimaryButton = this.store.selectSignal(AppFeature.state.selectIsOpen);

    currentTabIndex = signal<number>(0);

    changeCurrentTabIndex = (index: number) => {
        this.currentTabIndex.set(index);
    };

    activeCar = computed(() => {
        const campaignDetail = this.campaignDetail();
        if (campaignDetail && campaignDetail.salesContent) {
            return campaignDetail.salesContent.cars[this.currentTabIndex()];
        }
        return null;
    });

    queryParams = computed(() => {
        const campaignDetail = this.campaignDetail();
        if (campaignDetail && campaignDetail?.salesContent?.cars) {
            const carsNames = campaignDetail.salesContent.cars.map((car) => {
                let envkvModel: { vehicleMarketFilterParams?: string | null; name: string } | undefined | null;
                if (car.envkvDataSource?.__typename === 'Vehicle') envkvModel = car.envkvDataSource.model;

                if (car.envkvDataSource?.__typename === 'Model') envkvModel = car.envkvDataSource;

                return envkvModel ? this.getFilterModel(envkvModel) : car.name.trim();
            });
            const json = JSON.stringify({ model: carsNames }).replaceAll(/[\u200B-\u200D\uFEFF]/g, '');

            return {
                filter: json,
            };
        }
        return null;
    });

    getFilterModel(envkvModel: { vehicleMarketFilterParams?: string | null; name: string }): string {
        const filter = envkvModel.vehicleMarketFilterParams;
        if (filter) {
            const { model } = JSON.parse(filter);
            if (model && Array.isArray(model) && model.length > 0) {
                return model[0];
            }
        }
        return envkvModel.name;
    }

    campaignCars = computed(() => {
        return (
            this.campaignDetail().salesContent?.cars.map((car) => {
                return {
                    ...car,
                    envkv: { ...car.teaserEnvkvDataSource, envkvText: car.envkvText },
                };
            }) ?? []
        );
    });

    constructor() {
        effect(() => {
            const campaignDetail = this.campaignDetail();
            if (campaignDetail && campaignDetail.salesContent) {
                const cars = campaignDetail.salesContent.cars;

                untracked(() => {
                    const models = cars.map((m) => {
                        return {
                            name: m.name,
                        };
                    });
                    this.store.dispatch(TrackingFeature.actions.setModelsOnPageTracking({ models }));
                });
            }
        });
    }
}
